module.exports = __webpack_public_path__ + "img/E.Firma-12.8e1554b6.svg";